import { CollapsibleSection } from "../../components/CollapsibleSection";

interface MarkdownCheatsheetProps {
    isOpen?: boolean;
    onToggle?: () => void;
}

export function MarkdownCheatsheet({ isOpen, onToggle }: MarkdownCheatsheetProps) {
    return (
        <CollapsibleSection
            title="Cheatsheet"
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div className="text-sm flex flex-col gap-2.5">
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Header</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">#</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Bold</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">**</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Italic</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">*</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">List</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">-</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Link</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">[]()</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Image</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">![]()</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Code</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">`</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Quote</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center min-w-[3ch]">&gt;</span>
                </div>
                <div className="flex justify-between items-center group">
                    <span className="opacity-70">Mermaid</span>
                    <span className="font-mono bg-base-200 px-1.5 py-0.5 rounded text-center">```mermaid</span>
                </div>
            </div>
        </CollapsibleSection>
    );
}
